"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CouponInputComponent.default;
  }
});

var _CouponInputComponent = _interopRequireDefault(require("./CouponInput-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }